/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Faq_Q4Inputs */

const en_fw_faq_q4 = /** @type {(inputs: Fw_Faq_Q4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Who animates the Firefly Wedding anime?`)
};

const zh_fw_faq_q4 = /** @type {(inputs: Fw_Faq_Q4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`萤火之嫁动画由哪家公司制作？`)
};

/**
* | output |
* | --- |
* | "Who animates the Firefly Wedding anime?" |
*
* @param {Fw_Faq_Q4Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const fw_faq_q4 = /** @type {((inputs?: Fw_Faq_Q4Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Faq_Q4Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fw_faq_q4(inputs)
	return zh_fw_faq_q4(inputs)
});
export { fw_faq_q4 as "fw.faq.q4" }